import React from "react";
import { MdError, MdWarning, MdCheckCircle } from "react-icons/md";

export default function ValidationResults({ results }) {
  const { summary, errors, warnings } = results;

  return (
    <div className="validation-results mt-3 mb-3">
      {/* 요약 정보 */}
      <div className="row mb-3">
        <div className="col-md-3 col-6">
          <div className="card border-success">
            <div className="card-body text-center py-2">
              <h6 className="text-success mb-0">{summary.new}개</h6>
              <small className="text-muted">신규 생성</small>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="card border-warning">
            <div className="card-body text-center py-2">
              <h6 className="text-warning mb-0">{summary.update}개</h6>
              <small className="text-muted">기존 수정</small>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="card border-danger">
            <div className="card-body text-center py-2">
              <h6 className="text-danger mb-0">{summary.errors}개</h6>
              <small className="text-muted">오류</small>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="card border-primary">
            <div className="card-body text-center py-2">
              <MdCheckCircle className="text-success" size={24} />
              <h6 className="mt-1 mb-0">{summary.total}개</h6>
              <small className="text-muted">처리 가능</small>
            </div>
          </div>
        </div>
      </div>

      {/* 오류 목록 */}
      {errors.length > 0 && (
        <div className="alert alert-danger">
          <h6>
            <MdError className="me-2" />
            오류 ({errors.length}개)
          </h6>
          <div
            className="small"
            style={{ maxHeight: "150px", overflowY: "auto" }}
          >
            <ul className="mb-0">
              {errors.slice(0, 20).map((error, index) => (
                <li key={index}>{error}</li>
              ))}
              {errors.length > 20 && (
                <li className="text-muted">... 외 {errors.length - 20}개</li>
              )}
            </ul>
          </div>
        </div>
      )}

      {/* 경고 목록 */}
      {warnings.length > 0 && (
        <div className="alert alert-warning">
          <h6>
            <MdWarning className="me-2" />
            경고 ({warnings.length}개)
          </h6>
          <div className="small">
            <ul className="mb-0">
              {warnings.slice(0, 10).map((warning, index) => (
                <li key={index}>{warning}</li>
              ))}
              {warnings.length > 10 && (
                <li className="text-muted">... 외 {warnings.length - 10}개</li>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
